import React from 'react';

import Button from 'buyside/components/presentation/Button/button';
import IncompleteProfileModal from 'buyside/components/presentation/JobVaultShowPage/JobVaultShowModals/incompleteProfileModal';
import NoJobAccessModal from 'buyside/components/presentation/JobVaultShowPage/JobVaultShowModals/noJobAccessModal';

import { userJobApplicationsUrl, newJobApplication } from 'buyside/util/urlHelper';

const applyButtonOptions = {
  type: 'primary',
  size: 'small',
  text: 'Apply For This Job'
};

const JobVaultShowApplyButton = ({
  isApplicant,
  hasJobAccess,
  jobPostId,
  canApplyToJobs,
  disqualifiedReasons,
  isAllocator,
  ...props
}) => {
  if (isApplicant) {
    return (
      <Button
        id="apply-button"
        {...{
          ...applyButtonOptions,
          text: 'View Status of Your Application',
          url: userJobApplicationsUrl()
        }}
        {...props}
      />
    );
  }

  if (canApplyToJobs) {
    const url = jobPostId ? newJobApplication(jobPostId) : '#reasons';
    const text = disqualifiedReasons.length ? 'Apply Anyway' : applyButtonOptions.text;
    return <Button id="apply-button" {...{ ...applyButtonOptions, url, text }} {...props} />;
  }

  if (!hasJobAccess || isAllocator) {
    return <NoJobAccessModal isAllocator={isAllocator} {...applyButtonOptions} {...props} />;
  }

  if (hasJobAccess && !canApplyToJobs)
    return <IncompleteProfileModal {...applyButtonOptions} {...props} />;

  return null;
};

export default JobVaultShowApplyButton;
